import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c3e31eb&lang=scss&scoped=true"

import exportComponent from "/Users/tyk/Desktop/work/kangleiot/biz-sharingspace/sharing-space-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3e31eb"]])

export default __exports__